import "./FullMenu.module.css";
import Header from "@/reusable_sections/Header";
import OurFlavorGallery from "./sections/OurFlavorGallery";
import TacosSidesSips from "./sections/TacosSidesSips";
import Footer from "@/reusable_sections/Footer";
export default function FullMenuPage() {
  return <div>
      <Header />
      <OurFlavorGallery />
      <TacosSidesSips />
      <Footer />
    </div>;
}